module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "name": _vm.$parent.name,
      "id": _vm.$parent.inputId || _vm.$parent.name,
      "accept": _vm.$parent.accept,
      "capture": _vm.$parent.capture,
      "webkitdirectory": _vm.$parent.directory && _vm.$parent.features.directory,
      "directory": _vm.$parent.directory && _vm.$parent.features.directory,
      "multiple": _vm.$parent.multiple && _vm.$parent.features.html5
    },
    on: {
      "change": _vm.change
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71eda8ee"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/input-file.vue
// module id = 286
// module chunks = 107